module.exports = __webpack_public_path__ + "static/media/DuyenAvatar.bb8599a5.png";